import $ from 'jquery';
import api from '../apiService.js';
import {
    runDriverAutofill,
    runOtherDriverAutofill,
    runOwnerAutofill,
    runVehicleAutofill,
    runOtherVehicleAutofill,
    updateDriverFullName,
    updateOtherDriverFullName,
    updateInsuredFullName,
    updateOtherInsuredFullName,
    runCopyInsuredToOwner,
    runCopyInsuredToDriver,
    runCopyOtherInsuredToOtherDriver,
    runCopyOtherInsuredToOtherOwner,
} from './update-people-data.js';
import { searchCarAnia } from './search-car-ania';
import { fetchIstatCode } from './fetch-istat-code';
import { fetchIstatRegion } from './fetch-istat-region';
import { fetchExternalPersonData } from './claims-external-person-data';
import { fetchCurrentClaimDirection } from './fetch-current-claim-direction';
import './event-handlers';
import { clearFields, createDebouncedMemoRequest, disableSaveButton, populateFields, propSpinner } from '../utils.js';
import showConfirmationPopup from "../confirmationPopup";

window.runCopyInsuredToOwner = runCopyInsuredToOwner;
window.runCopyInsuredToDriver = runCopyInsuredToDriver;
window.runCopyOtherInsuredToOtherDriver = runCopyOtherInsuredToOtherDriver;
window.runCopyOtherInsuredToOtherOwner = runCopyOtherInsuredToOtherOwner;
window.runDriverAutofill = runDriverAutofill;
window.runVehicleAutofill = runVehicleAutofill;
window.runOtherVehicleAutofill = runOtherVehicleAutofill;
window.runOtherDriverAutofill = runOtherDriverAutofill;
window.runOwnerAutofill = runOwnerAutofill;
window.fetchIstatCode = fetchIstatCode;
window.fetchIstatRegion = fetchIstatRegion;
window.fetchExternalPersonData = fetchExternalPersonData;
window.fetchCurrentClaimDirection = fetchCurrentClaimDirection;
window.clearFields = clearFields;
window.updateOtherInsuredFullName = updateOtherInsuredFullName;
window.updateInsuredFullName = updateInsuredFullName;
window.updateOtherDriverFullName = updateOtherDriverFullName;
window.updateDriverFullName = updateDriverFullName;

window.fetchOtherCompanyName = async function fetchOtherCompanyName() {
    const fieldValue = $('[name=other_company_id]').val();
    if (!fieldValue || fieldValue.length === 0) {
        clearFields(['other_company']);
        return;
    }

    const debounceSearch = createDebouncedMemoRequest(api.getData, 300);

    propSpinner(['other_company'], true);
    disableSaveButton(true);

    const cacheKey = `other_company-${fieldValue}`;

    debounceSearch(cacheKey, `/api/card-companies/${fieldValue}`, {
        params: {},
    }).then((name) => {
        if (name) {
            populateFields({ 'other_company': name });
        }
    })
    .catch(() => {
        clearFields(['other_company']);
    })
    .finally(() => {
        propSpinner(['other_company'], false);
        disableSaveButton(false);
    });
};

window.onSearchCarAnia = function onSearchCarAnia(fieldName) {
    searchCarAnia(fieldName);
}

$('form').on('submit', function () {
    $(this).find(':disabled').prop('disabled', false);
});

$('form[action*="unisci-reclamo"]').on('submit', async function () {
    event.preventDefault();

    const confirmed = await showConfirmationPopup('Stai per unire il sinistro Y nel sinistro X. Sei ASSOLUTAMENTE sicuro? Il sinistro Y diventerà CHIUSO SENZA SEGUITO ed i suoi dati saranno spostati nel sinistro X');
    if (!confirmed) {
        $(this).find(':disabled').prop('disabled', false);
        return;
    }

    this.submit();
});

document.addEventListener("DOMContentLoaded", function () {
    function safeGetElement(id) {
        return document.getElementById(id) || null;
    }

    function storeInitialValues(prefixFrom) {
        document.querySelectorAll(`[name^="${prefixFrom}"]`).forEach(sourceElement => {
            let targetName = sourceElement.name.replace(prefixFrom, "");
            let possibleTargets = [
                `owner_${targetName}`, `driver_${targetName}`,
                `other_owner_${targetName}`, `other_driver_${targetName}`
            ];

            possibleTargets.forEach(target => {
                let targetElement = document.querySelector(`[name="${target}"]`);
                if (targetElement && !targetElement.hasAttribute("data-initial-value")) {
                    targetElement.setAttribute("data-initial-value", targetElement.type === "checkbox" ? targetElement.checked : targetElement.value);
                }
            });
        });
    }

    function copyValuesAndDisable(prefixFrom, prefixTo) {
        document.querySelectorAll(`[name^="${prefixFrom}"]`).forEach(sourceElement => {
            let targetName = sourceElement.name.replace(prefixFrom, "");
            let targetElement = document.querySelector(`[name="${prefixTo}${targetName}"]`);

            if (targetElement) {
                if (targetElement.type === "hidden") {
                    let parentElement = targetElement.parentNode;
                    if (parentElement) {
                        let nextElement = Array.from(parentElement.children).find(child => child !== targetElement);
                        if (nextElement) {
                            nextElement.style.display = "none";

                            let newCheckbox = document.createElement("input");
                            newCheckbox.type = "checkbox";
                            newCheckbox.checked = (sourceElement.value == "1");
                            newCheckbox.value = sourceElement.value;
                            newCheckbox.disabled = true;
                            newCheckbox.id = "new_" + targetElement.name;
                            parentElement.insertBefore(newCheckbox, parentElement.firstChild);
                        }
                    }

                    targetElement.value = sourceElement.value;
                } else if ($(targetElement).hasClass("select2")) {
                    $(targetElement).val(sourceElement.value || "").trigger("change.select2");
                } else {
                    targetElement.value = sourceElement.value || "";
                }

                targetElement.readOnly = true;
                targetElement.disabled = true;
            }
        });
    }

    function restoreInitialValuesAndEnable(prefixTo) {
        document.querySelectorAll(`[name^="${prefixTo}"]`).forEach(targetElement => {
            let initialValue = targetElement.getAttribute("data-initial-value");

            if (initialValue !== null) {
                if (targetElement.type === "hidden") {
                    let newCheckbox = document.querySelector(`#new_${targetElement.name}`);
                    if (newCheckbox) {
                        newCheckbox.remove();
                    }
                    let parentElement = targetElement.parentNode;
                    if (parentElement) {
                        let nextElement = Array.from(parentElement.children).find(child => child !== targetElement);
                        if (nextElement) {
                            nextElement.style.display = "";
                        }
                    }
                    targetElement.value = initialValue;
                } else {
                    targetElement.value = initialValue;
                }

                targetElement.readOnly = false;
                targetElement.disabled = false;
            }
        });
    }

    function bindEventListener(checkbox, sourcePrefix, targetPrefix) {
        if (checkbox) {
            checkbox.addEventListener("change", function () {
                if (checkbox.checked) {
                    copyValuesAndDisable(sourcePrefix, targetPrefix);
                } else {
                    restoreInitialValuesAndEnable(targetPrefix);
                }
            });

            if (checkbox.checked) {
                copyValuesAndDisable(sourcePrefix, targetPrefix);
            }
        }
    }

    storeInitialValues("insured_");
    storeInitialValues("owner_");
    storeInitialValues("driver_");
    storeInitialValues("other_insured_");
    storeInitialValues("other_owner_");
    storeInitialValues("other_driver_");

    bindEventListener(safeGetElement("insured_is_owner"), "insured_", "owner_");
    bindEventListener(safeGetElement("insured_is_driver"), "insured_", "driver_");
    bindEventListener(safeGetElement("owner_is_driver"), "owner_", "driver_");

    bindEventListener(safeGetElement("other_insured_is_owner"), "other_insured_", "other_owner_");
    bindEventListener(safeGetElement("other_insured_is_driver"), "other_insured_", "other_driver_");
    bindEventListener(safeGetElement("other_owner_is_driver"), "other_owner_", "other_driver_");

    function triggerInitialChanges() {
        const checkboxes = [
            "insured_is_owner",
            "insured_is_driver",
            "owner_is_driver",
            "other_insured_is_owner",
            "other_insured_is_driver",
            "other_owner_is_driver"
        ];

        checkboxes.forEach(id => {
            let checkbox = safeGetElement(id);
            if (checkbox && checkbox.checked) {
                $(checkbox).trigger("change");
            }
        });
    }

    triggerInitialChanges();
});
